import { BitrixVue } from 'ui.vue';
import { Dom } from 'main.core';
import { ProgressRound } from 'ui.progressround';

export const UploadLoader = BitrixVue.component('tile-uploader.uploader-loader', {
	mounted()
	{
		this.createProgressbar();
	},
	beforeDestroy()
	{
		this.removeProgressbar();
	},
	props: {
		progress: {
			type: Number,
			default: 0,
		},
		item: {
			type: Object,
			default: {}
		},
	},
	methods:
	{
		createProgressbar()
		{
			this.loader = new ProgressRound({
				width: 20,
				// colorTrack: '#d8d8d8',
				// colorBar: '#2fc6f6',
				colorTrack: '#73d8f8',
				colorBar: '#fff',
				lineSize: 3,
				rotation: true,
				color: ProgressRound.Color.SUCCESS,
			});

			this.loader.renderTo(this.$refs.container);
		},
		updateProgressbar()
		{
			if (this.item.status !== 'uploading')
			{
				return;
			}

			if (!this.loader)
			{
				this.createProgressbar();
			}

			this.loader.update(this.item.progress ? this.item.progress : 0);
		},
		removeProgressbar()
		{
			if (this.loader)
			{
				Dom.remove(this.loader.getContainer());
				this.loader = null;
			}
		}
	},
	computed:
	{
		uploadProgress()
		{
			return String(this.item.progress);
		},
	},
	watch:
	{
		uploadProgress()
		{
			this.updateProgressbar();
		},
	},
	template: `<div class="ui-tile-uploader-item-loader" ref="container"></div>`
});
